<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="padding-top:130px;">My interest in forensic psychology and the criminal psyche began at a rather early age. I have recollections of watching crime dramas as a young adult, and while they did entertain me, I always felt like something was missing. To me, the missing component was the “why”. It was not enough for me to view the behaviors, the investigations, the pursuit and the eventual apprehending of the perpetrator. I needed to know what the motivation was behind the heinous acts, what was the attacker thinking, or hope to accomplish. Basically I wondered what created this monster? Did he or she come out of the womb like this? Were they a product of their environment? Were there other factors that needed consideration?</p>
<p>Over the years the television and movie industry appeared to recognize the need that many of us had for this additional component. Many started addressing this factor, with my favorite being the television show <em>Criminal Minds</em>. This series centered around the motivation and psycho-pathology of the men and women committing the crimes. I was devastated when it went off the air.</p>
<p>I owe much gratitude to my dear friends who have supported me in my endeavors, and who have always offered encouragement. Shout outs to Tina Burnette, Pam Timmins, and many others. One of my biggest supporters has been my mother, Doris Laurange, who always has been there for me. Last, but certainly not least, I never would have even tried to undertake this without the unconditional love and support from the love of my life, David Schultz.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1f0b4dc4